import { Colors, Icon, Text, isIconName } from '@amelio/ui-library';

import type { ColorType } from '@amelio/ui-library';

import { ProficiencyIcon } from '@/components/ProficiencyIcon/ProficiencyIcon';
import { getIconEntry } from '@/constants/proficiencyIconCatalog';

interface ProficiencyLegendItemProps {
    iconUrl?: string;
    iconName?: string;
    iconColor?: string;
    label: string;
}

export const ProficiencyLegendItem = ({
    iconUrl,
    iconName,
    iconColor,
    label,
}: ProficiencyLegendItemProps) => {
    if (!iconUrl && !iconName) return null;

    const iconEntry = iconName ? getIconEntry(iconName) : undefined;

    return (
        <span className={'flex items-center gap-1'}>
            {iconEntry || iconUrl ? (
                <ProficiencyIcon
                    iconUrl={iconUrl}
                    iconEntry={iconEntry}
                    alt={label}
                    color={iconColor}
                    className={'h-4 w-4'}
                />
            ) : (
                <Icon
                    name={iconName && isIconName(iconName) ? iconName : 'time-clock'}
                    size={'sm'}
                    color={iconColor as ColorType}
                />
            )}
            {/* The icon carries the level's colour; the label stays grey: orange or light green
                text on white is too pale to read. */}
            <Text
                size={'small'}
                color={Colors.BASE_500}
            >
                {label}
            </Text>
        </span>
    );
};
